import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import SingleTranslatorSkeleton from "./SingleTranslator/SingleTranslatorSkeleton";

const SKELETON_KEYS = ["a", "b", "c", "d", "e", "f", "g", "h"];

const TranslatorsPageSkeleton = () => (
	<Box sx={{ width: "100%", pt: 2 }}>
		<Grid container spacing={2}>
			{SKELETON_KEYS.map((key) => (
				<Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={key}>
					<Card
						sx={{
							height: "100%",
							display: "flex",
							flexDirection: "column",
						}}
					>
						<SingleTranslatorSkeleton />
					</Card>
				</Grid>
			))}
		</Grid>
	</Box>
);

export default TranslatorsPageSkeleton;
